import React from 'react';
import { 
  ListItem, 
  ListItemButton, 
  ListItemIcon, 
  Checkbox, 
  ListItemText, 
  IconButton,
  CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { TodoWithState } from '../../types/todos';

interface TodoItemProps {
  todo: TodoWithState;
  onToggle: (id: string, isComplete: boolean) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}

const TodoItem: React.FC<TodoItemProps> = ({ todo, onToggle, onDelete }) => {
  const handleToggle = () => {
    onToggle(todo.id, todo.is_complete);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(todo.id);
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton 
          edge="end" 
          aria-label="delete" 
          onClick={handleDelete}
          disabled={todo.isLoading}
        >
          <DeleteIcon />
        </IconButton>
      }
      disablePadding
    >
      <ListItemButton onClick={handleToggle} disabled={todo.isLoading} dense>
        <ListItemIcon>
          {todo.isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <Checkbox
              edge="start"
              checked={todo.is_complete}
              tabIndex={-1}
              disableRipple
            />
          )}
        </ListItemIcon>
        <ListItemText 
          primary={todo.title}
          sx={{
            textDecoration: todo.is_complete ? 'line-through' : 'none',
            color: todo.is_complete ? 'text.secondary' : 'text.primary'
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default TodoItem;